import { useEffect, useRef, useState } from 'react'
import { BellRing, CircleAlert, CircleCheck } from 'lucide-react'
import { api } from '../api'

type LatestEvent = {
  execution_event_id: string
  strategy_name: string
  event_name: string
  status: string
  details: Record<string, any>
}

const alertable = new Set(['SUBMITTED', 'NETTED_NO_ORDER', 'ERROR', 'REJECTED_POSITION_MISMATCH', 'MISSED_WINDOW'])
const failed = new Set(['ERROR', 'REJECTED_POSITION_MISMATCH', 'MISSED_WINDOW'])

export default function PaperExecutionNotifier() {
  const latestId = useRef<string | null>(null)
  const [event, setEvent] = useState<LatestEvent | null>(null)

  useEffect(() => {
    let timer: number | undefined
    const load = async () => {
      try {
        const page = await api<{ items: LatestEvent[] }>('/api/catalog/paper-execution-events?limit=1&offset=0')
        const current = page.items[0]
        if (!current) return
        if (latestId.current && latestId.current !== current.execution_event_id && alertable.has(current.status)) {
          setEvent(current)
          window.clearTimeout(timer)
          timer = window.setTimeout(() => setEvent(null), 12_000)
        }
        latestId.current = current.execution_event_id
      } catch {
        // The operations page exposes connectivity details; a transient polling failure must not spam UI.
      }
    }
    load()
    const interval = window.setInterval(load, 10_000)
    return () => { window.clearInterval(interval); window.clearTimeout(timer) }
  }, [])

  if (!event) return null
  const action = event.details.net_order?.action || event.details.action || 'nessuna variazione netta'
  const isFailure = failed.has(event.status)
  return <aside className={`paper-toast ${isFailure ? 'failure' : 'success'}`} role="status">
    {isFailure ? <CircleAlert size={20} /> : <CircleCheck size={20} />}
    <div><strong>{isFailure ? 'Attenzione paper IBKR' : 'Evento paper IBKR'}</strong><span>{event.strategy_name} · {event.event_name}</span><small>{event.status} · {action}</small></div>
    <BellRing size={16} />
  </aside>
}
